import { useDebounce } from "@api";
import type { ICandidate } from "@bbj-types/candidate";
import { useGetAutocompleteCandidate } from "@root/api/services/candidates/autocomplete";
import { type SyntheticEvent, useEffect, useState } from "react";

export type TAutocompleteCandidateValue = Partial<ICandidate> & {
  _id: string;
  lastName: string;
  profileId: number;
  firstName?: string;
};

export interface IUseAutocompleteCandidates {
  options: TAutocompleteCandidateValue[];
  getDebounceCandidates: (_: SyntheticEvent<Element, Event>, value: string) => void;
}

export const useAutocompleteCandidates = (): IUseAutocompleteCandidates => {
  const [{ data }, getCandidates] = useGetAutocompleteCandidate();
  const [options, setOptions] = useState<TAutocompleteCandidateValue[]>([]);

  const getCandidatesOnInput = async (value: string) => {
    if (value.length < 2) {
      setOptions([]);
      return;
    }
    await getCandidates({ name: value });
  };

  const getDebounceCandidates = useDebounce(
    (_: SyntheticEvent<Element, Event>, value: string) => {
      void getCandidatesOnInput(value);
    },
    750,
    []
  );

  useEffect(() => {
    if (data) setOptions(data);
  }, [data]);

  return { options: options, getDebounceCandidates };
};
